var base = require('kiosk/metrics');

Vue.component('spark-kiosk-metrics', {
    mixins: [base],
    data(){
        return {
            headers: [{
                text: 'Name', value: 'name', align: 'left', sortable: false
            },{
                text: 'Subscribers', value: 'count', sortable: false
            },{
                text: 'Trialing', value: 'trialing', sortable: false
            }]
        };
    },
    computed: {
        subscriptions: function(){
            var items = this.plans;
            if(this.genericTrialUsers){
                var json = {
                    name: 'On Generic Trial',
                    count: 'N/A',
                    trailing: this.genericTrialUsers
                };
                items.unshift(json);
            }
            return items;
        }
    }
});
